export const FORGET_PASSWORD = "FORGET_PASSWORD";

export const RESET_PASSWORD = "RESET_PASSWORD";